import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { GTM_ID, GTM_AUTH, GTM_PREVIEW } from './config'
import Journey from './pages/JourneyWidget';
import './styles/base.css';

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
    gtag: Function;
  }
}

function gtag() {window.dataLayer.push(arguments)};

function App() {

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    if (search.get("analyticsMode") !== "POST_MESSAGE") {
      window.dataLayer = window.dataLayer || [];
      window.gtag = gtag;
      TagManager.initialize({gtmId: GTM_ID, auth: GTM_AUTH, preview: GTM_PREVIEW});
    }
  }, [])

  return (
    <Journey />
  );
}

export default App;
